<bootstrap-popup
	[id]="id"
	[title]="'Associer l\'accès à des opérations et demandes d\'intervention'"
	[windowCloseButton]="true" [modalSize]="'modal-lg'" 
	[displaySubject]="displaySubject"
	>
	<ng-container *ngIf="loaded">
		<h3 class="row align-items-center m-0">
		    
		    <div class="col-sm-9">
		        <span>
		            Acc&egrave;s <b>{{ acces.numero }}</b> 
		            <ng-container *ngIf="ouvrages.length">
		                {{ ouvrages.length == 1 ? ' sur l\'ouvrage ' : ' sur les ouvrages ' }} 
		                <b>{{ ouvrages[0].nom }}</b>
		                <ng-container *ngIf="ouvrages.length >= 2">
		                    &nbsp;, <b>{{ ouvrages[1].nom }}</b>
		                </ng-container>
		                <ng-container *ngIf="ouvrages.length >= 3">
		                    &nbsp;, ...
		                </ng-container>
		            </ng-container>
		            le {{ acces.dateDebut | localDateTimeToDate : acces.ice | date : "dd/MM/yyyy '&agrave;' HH:mm"}}
		        </span>
		    </div>
		
			<div class="col-sm-3 text-right">
			    <label for="aucunActeAssociable" style="font-weight: normal; font-size: 0.85em; margin-right: 4px;">Aucun acte O&amp;M</label>
			    <input
			        type="checkbox"
			        id="aucunActeAssociable"
			        [(ngModel)]="accesOperationBinder.aucunActeAssociable"
			        name="aucunActeAssociable"
			    />
			</div>
		
		</h3>
		<form class="form-horizontal">
			<acces-operation-binder [acces]="acces" 
				(onBindingOperation)="onBindingOperation($event)" 
				(onAfterChargementActes)="onAfterChargementActes($event)"
				(onBindingWorkOrder)="onBindingWorkOrder($event)"  
				(onBindingNotification)="onBindingNotification($event)"
				[aucunActeAssociable]="accesOperationBinder.aucunActeAssociable"
				(hasSelectionChange)="onBinderSelectionChange($event)" >
			</acces-operation-binder>
		</form>			
	</ng-container>
	<ng-container *ngIf="!loaded">
		Chargement...
	</ng-container>
	<div class="modal-footer">
		<div class="form-group text-center">
			<br/>
			<button type="button" class="btn default" (click)="close()">Annuler</button>
			<ng-container *ngIf="acces">
				<button type="button" class="btn btn-success" (click)="terminer()" *ngIf="hasSomeActes"
					[disabled]="shouldDisableButtons" >Terminer l'association</button>
				<button type="button" class="btn btn-primary" (click)="close()" *ngIf="!hasSomeActes">Fermer</button>
			</ng-container>
		</div>
	</div>	   	
</bootstrap-popup>
					